// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Tf","landingPageVideo":"Uf","play":"Vf","iframeVideo":"Wf","playHidden":"Xf","playVisible":"Yf","fullwidth":"Zf"};